module.exports = __webpack_public_path__ + "static/a1db628910baf1585abeeb1d1cb9bbf988052f2ccb5fb3a1e2b55626a773aa09-77bb9b68cde33671aeecd8081b78ee28.png";